import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Contact {
    id: number;
    [key: string]: any;
}

interface ContactsState {
    items: Contact[];
    current: Contact | null;
    loading: boolean;
    error: string | null;
}

const initialState: ContactsState = {
    items: [],
    current: null,
    loading: false,
    error: null,
};

const contactsSlice = createSlice({
    name: "contacts",
    initialState,
    reducers: {
        setContacts(state, action: PayloadAction<Contact[]>) {
            state.items = action.payload;
            state.loading = false;
            state.error = null;
        },
        setContact(state, action: PayloadAction<Contact | null>) {
            state.current = action.payload;
        },
        setContactsLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setContactsError(state, action: PayloadAction<string | null>) {
            state.error = action.payload;
            state.loading = false;
        },
        clearContacts(state) {
            state.items = [];
            state.current = null;
        },
    },
});

export const { setContacts, setContact, setContactsLoading, setContactsError, clearContacts } =
    contactsSlice.actions;

export default contactsSlice.reducer;
